import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UtilService} from '../../util/util.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  public tokenId: string;
  public registerDetail: FormGroup;
  public userDetails: any = {};
  public fullNameData: any = {};
  public isConnected = true;
  public crd : any = {};

  @ViewChild('popupTOC') popupTOC: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private loanService: LoanService,
    private modalService: NgbModal,
    private utilService : UtilService
  ) {
  }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);
    
    this.registerDetail = this.fb.group({
      firstName: ['', Validators.compose([Validators.required])],
      lastName: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
      password: ['', Validators.compose([Validators.required])],
      confirmPassword: ['', Validators.compose([Validators.required])],
      agree: ['', Validators.compose([Validators.required])]
    }, {
      validator: PasswordValidation.MatchPassword
    });

    this.activeRoute.data.subscribe((res: any) => {
      if (res && res.loanDetail) {
        this.tokenId = res.loanDetail.token;
        this.userDetails = res.loanDetail.Customer;

        this.fullNameData = this.userDetails.fullName.split(' ');
        if (this.fullNameData.length === 1) {
          this.firstName.setValue(this.fullNameData[0]);
        } else if (this.fullNameData.length >= 2) {
          this.lastName.setValue(this.fullNameData.pop());
          this.firstName.setValue(this.fullNameData.join(' '));
        }
        this.registerDetail.patchValue({
          email: this.userDetails.email,
          phone: this.userDetails.mobile
        });
        this.firstName.markAsTouched();
        this.lastName.markAsTouched();
        this.email.markAsTouched();
        this.phone.markAsTouched();
      }
    });
  }

  get firstName() {
    return this.registerDetail.get('firstName');
  }

  get lastName() {
    return this.registerDetail.get('lastName');
  }

  get email() {
    return this.registerDetail.get('email');
  }

  get phone() {
    return this.registerDetail.get('phone');
  }

  get password() {
    return this.registerDetail.get('password');
  }

  get confirmPassword() {
    return this.registerDetail.get('confirmPassword');
  }

  get agree() {
    return this.registerDetail.get('agree');
  }

  changeEvent(event) {
    if (event.target.checked) {
      this.agree.setValue(true);
    }
    else {
      this.agree.setValue('');
    }
  }

  goToLogin() {
    this.router.navigateByUrl(`/authentication`);
  }

  async goNext() {
    if(!this.crd.status){
      return false;
    }
    let details = this.crd.data;
    let formdata = {
      firstName: this.registerDetail.get('firstName').value,
      lastName: this.registerDetail.get('lastName').value,
      email: this.registerDetail.get('email').value,
      mobile: this.registerDetail.get('phone').value,
      password: this.registerDetail.get('password').value,
      skipRegister: false,
      ...details
    };
    this.loanService.signup(formdata, this.tokenId).subscribe((res: any) => {
      let LeadredirectionUrl = res.data.Lead ? res.data.Lead.redirectionUrl : "";
      if (LeadredirectionUrl) {
        if (!LeadredirectionUrl.startsWith('http://') && !LeadredirectionUrl.startsWith('https://')) {
            LeadredirectionUrl = 'https://' + LeadredirectionUrl;
        }
        window.location.href = LeadredirectionUrl;
      }else{
        this.router.navigateByUrl(`/authentication`);
      }
    }, (errors) => {
      for (let error of errors) {
        if (error.field === 'mobile') error.field = 'phone';
        if (!this.registerDetail.get(error.field)) continue;
        this.registerDetail.get(error.field).setErrors({server: error.message});
      }
    });
  }

  open(content) {
    this.modalService.open(content);
  }

  openTOC() {
    this.open(this.popupTOC);
  }

  pattern(regExp: string, value: string) {
    return new RegExp(regExp).test(value);
  }
}

export class PasswordValidation {
  static MatchPassword(AC: AbstractControl) {
    let password = AC.get('password').value;
    let confirmPassword = AC.get('confirmPassword').value;
    if (password != confirmPassword) {
      AC.get('confirmPassword').setErrors({MatchPassword: true});
    } else {
      return null;
    }
  }
}
